'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UILock from 'ui-addon-upgrades/icons/UILock';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getMABCreatableMap, getIsAnyTestRunning } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getActiveStagingDomain } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
import { getPortalHasABTesting } from 'ContentEditorUI/redux/selectors/portalSelectors';
import { requestUninitialized, requestStarted, requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import { getPortalScopesRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { Map as ImmutableMap } from 'immutable';
import EPPatagoniaCategoryNavItem from 'editor-components/sidebar/EPPatagoniaCategoryNavItem';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { TEST_MODAL_TYPES, NO_TEST_ACCESS } from 'ContentEditorUI/lib/modalConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PQLWrapper = () => {
  const {
    openUpgradeModal: openABTestUpgradeModal
  } = useUpgradeModal('landing-pages-ab-testing-editor');
  return /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
    iconRight: /*#__PURE__*/_jsx(UILock, {}),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `patagonia.sidebar.toolsMenu.runABTest`
    }),
    onClick: openABTestUpgradeModal
  });
};
const MABPQLWrapper = () => {
  const {
    openUpgradeModal: openAdaptiveTestUpgradeModal
  } = useUpgradeModal('landing-pages-adaptive-testing-editor-content-hub');
  return /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
    iconRight: /*#__PURE__*/_jsx(UILock, {}),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `patagonia.sidebar.toolsMenu.runMABTest`
    }),
    onClick: openAdaptiveTestUpgradeModal
  });
};
const mapStateToProps = state => ({
  isStagedContent: Boolean(getActiveStagingDomain(state)),
  portalHasABTesting: getPortalHasABTesting(state),
  portalScopesRequest: getPortalScopesRequest(state),
  mabCreatableMap: getMABCreatableMap(state),
  isAnyTestRunning: getIsAnyTestRunning(state)
});
class PatagoniaRunATestWrapper extends Component {
  renderInfoToolTip() {
    const {
      isAnyTestRunning
    } = this.props;
    return /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'mab.buttons.mab.disabledTooltip.hasTestRunning'
      }),
      placement: "right",
      children: isAnyTestRunning && /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        className: "m-left-1"
      })
    });
  }
  renderRunTestOption() {
    const {
      isAnyTestRunning,
      isStagedContent,
      portalHasABTesting,
      portalScopesRequest,
      mabCreatableMap,
      openModal
    } = this.props;

    // Do not show PQL or create test button for staged content or if this page is already part of
    // a test (maybe when the user/account downgraded and no longer has the test scope)
    if (isStagedContent) {
      return null;
    }
    const showPQL = requestSucceeded(portalScopesRequest) && !portalHasABTesting;
    const showMABPQL = mabCreatableMap.get('disabled') && mabCreatableMap.get('reason') === NO_TEST_ACCESS && requestSucceeded(portalScopesRequest);
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [!showPQL && /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
        title: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: `patagonia.sidebar.toolsMenu.runABTest`
          }), isAnyTestRunning && this.renderInfoToolTip()]
        }),
        onClick: () => openModal(TEST_MODAL_TYPES.AB_TEST),
        disabled: isAnyTestRunning
      }), showPQL && /*#__PURE__*/_jsx(PQLWrapper, {}), !showMABPQL && /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
        title: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: `patagonia.sidebar.toolsMenu.runMABTest`
          }), isAnyTestRunning && this.renderInfoToolTip()]
        }),
        onClick: () => openModal(TEST_MODAL_TYPES.MAB_TEST),
        disabled: isAnyTestRunning
      }), showMABPQL && /*#__PURE__*/_jsx(MABPQLWrapper, {})]
    });
  }
  render() {
    const {
      portalScopesRequest
    } = this.props;
    if (requestStarted(portalScopesRequest) || requestUninitialized(portalScopesRequest)) {
      return null;
    }
    return this.renderRunTestOption();
  }
}
PatagoniaRunATestWrapper.propTypes = {
  isStagedContent: PropTypes.bool.isRequired,
  portalHasABTesting: PropTypes.bool.isRequired,
  portalScopesRequest: PropTypes.object.isRequired,
  openModal: PropTypes.object.isRequired,
  mabCreatableMap: PropTypes.instanceOf(ImmutableMap),
  isAnyTestRunning: PropTypes.bool.isRequired
};
export default connect(mapStateToProps, null)(PatagoniaRunATestWrapper);